import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormikContext } from "formik";
import { PorductBreadcrumbWrapper } from "./product-breadcrumb.styled";
import Breadcrumbs from "@dashboard/components/breadcrumbs/breadcrumbs";
import { FormProps } from "@dashboard/modules/products/types/product-form.types";
import { isService } from "@dashboard/modules/products/utils/service-form.utils";

const ProductBreadcrumb: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { values } = useFormikContext<FormProps>();
  const service = isService(values);

  const breadcrumbRoutes = useMemo(() => {
    const entityName = service
      ? t("productComponent.service.name")
      : t("productComponent.product.name");

    const createLabel = service
      ? t("productComponent.service.breadcrumb.createPath")
      : t("productComponent.product.breadcrumb.createPath");
    const editLabel = service
      ? t("productComponent.service.breadcrumb.editPath")
      : t("productComponent.product.breadcrumb.editPath");

    const auxRoutes = [
      { label: entityName },
      {
        label: pathname.includes("new") ? createLabel : editLabel,
      },
    ];

    if (pathname.includes("images")) {
      auxRoutes.push({
        label: t("productComponent.product.breadcrumb.editPhotos"),
      });
    }
    if (pathname.includes("features")) {
      auxRoutes.push({
        label: t("productComponent.product.breadcrumb.editFeatures"),
      });
    }
    if (pathname.includes("stock")) {
      auxRoutes.push({
        label: t("productComponent.product.breadcrumb.editStock"),
      });
    }
    if (pathname.includes("professionals")) {
      auxRoutes.push({
        label: t("productComponent.service.breadcrumb.editProfessionals"),
      });
    }
    return auxRoutes;
  }, [pathname, service, t]);

  const handleCustomGoToBack = () => {
    const auxRoutes = pathname.split("/");
    if (auxRoutes.length === 5 && auxRoutes[3] === "edit") {
      navigate(`../../../../${id}/products`);
    } else {
      navigate(-1);
    }
  };

  return (
    <PorductBreadcrumbWrapper>
      <Breadcrumbs
        items={breadcrumbRoutes}
        customGoToBack={handleCustomGoToBack}
        backButton
      />
    </PorductBreadcrumbWrapper>
  );
};

export default ProductBreadcrumb;
